"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var appraisal_1 = require("../../../shared/model/appraisal");
var router_1 = require("@angular/router");
var appraisal_service_1 = require("../../service/appraisal.service");
var appraisal_test_service_1 = require("../../service/appraisal-test.service");
var equipment_1 = require("../../../shared/model/equipment");
var equipment_model_1 = require("../../../shared/model/equipment-model");
var sim_card_1 = require("../../../shared/model/sim-card");
var access_1 = require("../../../shared/model/access");
var telecom_provider_1 = require("../../../shared/model/telecom-provider");
var moment = require("moment");
var toast_service_1 = require("../../../shared/service/toast.service");
var AppraisalVisualizeComponent = /** @class */ (function () {
    function AppraisalVisualizeComponent(_route, _appraisalService, _appraisalTestService, _toastService) {
        this._route = _route;
        this._appraisalService = _appraisalService;
        this._appraisalTestService = _appraisalTestService;
        this._toastService = _toastService;
        this.unavailable = 'Indisponível';
        this.setUpObservers();
        this.setEmptyEntities();
        this.findAppraisal();
    }
    AppraisalVisualizeComponent.prototype.ngOnInit = function () {
    };
    AppraisalVisualizeComponent.prototype.findAppraisal = function () {
        var _this = this;
        this._route.params.subscribe(function (params) {
            if (params['id']) {
                var appraisalId = +params['id'];
                _this._appraisalService.findById(appraisalId);
                _this._appraisalTestService.findAsMap(appraisalId);
            }
        });
    };
    AppraisalVisualizeComponent.prototype.setUpObservers = function () {
        var _this = this;
        this._appraisalService.find$
            .filter(function (appraisal) { return appraisal instanceof appraisal_1.Appraisal; })
            .subscribe(function (appraisal) { return _this.appraisal = appraisal; });
        this._appraisalService.error$
            .subscribe(function (error) { return _this.showMessage(error.text); });
        this._appraisalTestService.find$
            .subscribe(function (testItems) { return _this.appraisalTestsItems = testItems; });
    };
    AppraisalVisualizeComponent.prototype.downloadAppraisal = function () {
        this._appraisalService.downloadAppraisal(this.appraisal);
    };
    AppraisalVisualizeComponent.prototype.setEmptyEntities = function () {
        this.appraisal = new appraisal_1.Appraisal();
        this.appraisal.files = [];
        this.appraisal.equipment = new equipment_1.Equipment();
        this.appraisal.equipment.equipmentModel = new equipment_model_1.EquipmentModel();
        this.appraisal.equipment.equipmentModel.equipmentManufacturer = {};
        this.appraisal.equipment.equipmentModel.equipmentManufacturer.equipmentType = {};
        this.appraisal.equipment.simCard = new sim_card_1.SimCard();
        this.appraisal.equipment.simCard.access = new access_1.Access();
        this.appraisal.equipment.simCard.telecomProvider = new telecom_provider_1.TelecomProvider();
    };
    AppraisalVisualizeComponent.prototype.formatDate = function (date) {
        if (date) {
            return moment(date).format('DD/MM/YYYY HH:mm');
        }
        return null;
    };
    AppraisalVisualizeComponent.prototype.getObjectKeys = function (object) {
        if (object) {
            return Object.keys(object);
        }
        return [];
    };
    AppraisalVisualizeComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    AppraisalVisualizeComponent.ctorParameters = function () { return [{ type: router_1.ActivatedRoute }, { type: appraisal_service_1.AppraisalService }, { type: appraisal_test_service_1.AppraisalTestService }, { type: toast_service_1.ToastService }]; };
    return AppraisalVisualizeComponent;
}());
exports.AppraisalVisualizeComponent = AppraisalVisualizeComponent;
//# sourceMappingURL=appraisal-visualize.component.js.map


// WEBPACK FOOTER //
// appraisal-visualize.component.js